// src/components/molecules/landing/faq-filter-tabs.tsx
"use client";

import { cn } from "@/lib/utils";

export type FaqCategory =
  | "All"
  | "Product"
  | "Payment"
  | "Compliant"
  | "Integration"
  | "Optimization"
  | "Automation";

type FaqFilterTabsProps = {
  active: FaqCategory;
  onChange: (value: FaqCategory) => void;
  options: FaqCategory[];
  className?: string;
};

export function FaqFilterTabs({
  active,
  onChange,
  options,
  className,
}: FaqFilterTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="FAQ categories"
      className={cn("flex flex-wrap items-center gap-2", className)}
    >
      {options.map((option) => {
        const selected = active === option;
        return (
          <button
            key={option}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(option)}
            className={cn(
              "inline-flex min-h-11 items-center rounded-full border px-4 text-sm font-medium transition-colors",
              selected
                ? "border-brand bg-brand text-white"
                : "border-brand-border bg-white text-brand-ink hover:bg-brand-muted",
            )}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
